import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from 'src/app/shared/forms/dynamic-form/dynamic-form.service';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { ToggelComponent } from '../../../design-system/toggel/toggel.component';

@Component({
    selector: 'formly-toggle',
    templateUrl: "./formly-toggle.component.html",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, ToggelComponent]
})
export class FormlyToggleComponent extends FieldType implements OnInit, OnDestroy {
    constructor(private dynamicFormService: DynamicFormService) {
        super();
    }

    param: any;
    isFormSubmitted: boolean = false;
    formSubmissionSubscription: Subscription;
    valueChangesSubscription: Subscription;
    fieldKey: string;
    enableBigToggle = true;
    // Optional title variant: a fixed title beside the switch, with an optional state-dependent
    // description under it. Turned on by a `description` (or descriptionActive/descriptionDeactive),
    // or by `showTitle` for a title with no second line, so existing single-label usages of this
    // generic control are unaffected.
    hasDescription = false;
    // Bare-switch variant only: a toggle sharing a grid row with a form control needs the row's
    // height, or the ~20px switch sits off the control's centre line. `withInput` matches a bare
    // input, `withInputLabel` one carrying its label above it.
    withInput = false;
    withInputLabel = false;
    titleLabel = '';
    description = '';
    toggleConfig = {
        label: '',
        labelPosition: 'left',
        size: 'md',
        isActive: true,
        disabled: false,
        id: ''
    }

    ngOnInit() {
        if (this.field.key) {
            this.fieldKey = this.field.id ?? this.field.key.toString();
        }
        this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
            this.isFormSubmitted = data;
        });
        if (this.to.options && this.to.options[0] && this.to.options[0].enableBigToggle != undefined) {
            this.enableBigToggle = this.to.options[0].enableBigToggle;
        }
        if (this.field.templateOptions) {
            this.toggleConfig.label = this.field.templateOptions.label;
            this.toggleConfig.labelPosition = this.field.templateOptions.labelPosition;
            this.toggleConfig.disabled = this.field.templateOptions.disabled;
            this.toggleConfig.size = this.field.templateOptions.size;
            this.toggleConfig.isActive = this.formControl.value;
            this.toggleConfig.id = this.fieldKey;
        }
        if (this.to) {
            this.toggleConfig.label = this.toggleConfig.isActive ? (this.to.labelActive || this.toggleConfig.label) : (this.to.labelDeactive || this.toggleConfig.label);
        }

        // Title variant: keep the title fixed and render any description separately. The switch itself
        // shows no label so the title isn't duplicated. `showTitle` covers the case of a title with no
        // description at all - the row still needs the title slot, which the bare-switch branch has not got.
        this.withInput = !!(this.to && this.to.withInput);
        this.withInputLabel = !!(this.to && this.to.withInputLabel);
        this.hasDescription = !!(this.to && (this.to.description || this.to.descriptionActive
            || this.to.descriptionDeactive || this.to.showTitle));
        if (this.hasDescription) {
            this.titleLabel = this.field.templateOptions?.label || '';
            this.description = this.fnResolveDescription(this.toggleConfig.isActive);
            this.toggleConfig.label = '';
        }

        if (this.formControl && this.formControl.valueChanges) {
            // this.valueChangesSubscription = this.formControl.valueChanges.subscribe(val => {
            //     this.toggleConfig.isActive = !!val;
            //     this.toggleConfig.label = this.toggleConfig.isActive ? (this.to.labelActive || this.toggleConfig.label) : (this.to.labelDeactive || this.toggleConfig.label);
            // });
            this.valueChangesSubscription = this.formControl.valueChanges.subscribe(val => {
                const isActive = !!val;
                this.toggleConfig = {
                    ...this.toggleConfig,
                    isActive,
                    label: this.hasDescription ? '' : (isActive ? (this.to.labelActive || this.toggleConfig.label) : (this.to.labelDeactive || this.toggleConfig.label))
                };
                if (this.hasDescription) {
                    this.description = this.fnResolveDescription(isActive);
                }
            });
        }
    }

    // Resolves the description text: swaps between active/deactive variants when supplied, otherwise
    // falls back to the static `description`.
    private fnResolveDescription(isActive: boolean): string {
        if (this.to && (this.to.descriptionActive || this.to.descriptionDeactive)) {
            return isActive ? (this.to.descriptionActive || '') : (this.to.descriptionDeactive || '');
        }
        return (this.to && this.to.description) || '';
    }

    ngOnDestroy() {
        if (this.formSubmissionSubscription) {
            this.formSubmissionSubscription.unsubscribe();
        }
        if (this.valueChangesSubscription) {
            this.valueChangesSubscription.unsubscribe();
        }
    }

    onValueChange(event) {
        // A user toggling is a real change: setValue alone doesn't dirty the control. Mark it dirty/touched
        // BEFORE setValue so the valueChanges it fires already sees a dirty control - otherwise consumers
        // gating on form.dirty (e.g. a Save button) read the stale (false) state and only react next time.
        this.formControl.markAsDirty();
        this.formControl.markAsTouched();
        this.formControl.setValue(event);
        // `change` is optional on this generic control - only invoke it when the field provides one.
        if (this.to && typeof this.to.change === 'function') {
            this.to.change(this.field, this.formControl.value);
        }
        // this.toggleConfig.isActive = this.formControl.value;
        // this.toggleConfig.label = this.toggleConfig.isActive ? this.to.labelActive : this.to.labelDeactive;
    }
}